import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import config from '~/config';
const Logos = () => <div className={logosWrapperCss}>
    <p className="developer-text">Được phát triển bởi</p>
    <div>
      <Link className={`${logoWrapperCss} chotot-link`} id="chotot-link" href={config.baseUrl} target="_blank">
        <Image className={logoCss} fill sizes="(max-width: 768px) 25vw, 10vw" src="https://static.chotot.com/storage/logo/png/chotot-id/footer/gds.png" alt="GDS" />
      </Link>

      <div className={dividerCss} />

      <Link id="nhatot-link" className={`${logoWrapperCss} nhatot-link`} href={config.ptyBaseUrl} target="_blank">
        <Image className={logoCss} fill sizes="(max-width: 768px) 25vw, 10vw" src="https://static.chotot.com/storage/logo/png/chotot-id/footer/pty.png" alt="PTY" />
      </Link>

      <div className={dividerCss} />

      <Link id="vieclamtot-link" className={`${logoWrapperCss} vieclamtot-link`} href={config.jobBaseUrl} target="_blank">
        <Image className={logoCss} fill sizes="(max-width: 768px) 25vw, 10vw" src="https://static.chotot.com/storage/logo/png/chotot-id/footer/job.png" alt="JOB" />
      </Link>

      <div className={dividerCss} />

      <Link id="chototxe-link" className={`${logoWrapperCss} chototxe-link`} href={config.vehBaseUrl} target="_blank">
        <Image className={logoCss} fill sizes="(max-width: 768px) 25vw, 10vw" src="https://static.chotot.com/storage/logo/png/chotot-id/footer/veh.png" alt="VEH" />
      </Link>
    </div>
  </div>;
const dividerCss = "dzjkpvr";
const logosWrapperCss = "l1qyiawz";
const logoCss = "l2vm635";
const logoWrapperCss = "ltq2xbi";
export default Logos;

require("./Logos.linaria.module.css");